import { Action } from 'redux';
import {
  PARTNER_DASHBOARD_FETCH,
  PARTNER_DASHBOARD_RESET,
} from 'src/modules/partner-dashboard/actions/PartnerDashboardActions';
import { PartnerDashboardState } from 'src/modules/partner-dashboard/types/PartnerDashboardState';

export function partnerDashboardDataReducer(state: PartnerDashboardState, action: Action): PartnerDashboardState {
  if (PARTNER_DASHBOARD_FETCH.is(action)) {
    return { ...state, data: action.data };
  }
  if (PARTNER_DASHBOARD_RESET.is(action)) {
    return { ...state, data: null };
  }

  return state;
}
